import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnChanges,
  OnDestroy,
  SimpleChanges,
} from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { Subject, takeUntil } from 'rxjs';
import { ApiServiceService } from '../api-service.service';

@Component({
  selector: 'app-state-wise-user-select-component',
  templateUrl: './state-wise-user-select-component.component.html',
  styleUrls: ['./state-wise-user-select-component.component.scss'],
  standalone: true,
  imports: [
    MatFormField,
    MatLabel,
    MatSelect,
    FormsModule,
    MatOption,
    NgxMatSelectSearchModule,
    ReactiveFormsModule,
  ],
})
export class StateWiseUserSelectComponentComponent
  implements OnInit, OnDestroy, OnChanges
{
  @Input() defaultState: string[] = [];
  @Input() allStates = [];
  @Input() index = 0;
  @Output() remarkChange = new EventEmitter<unknown>();

  filteredListOfState = [];
  stateNameFilterCtrl: FormControl = new FormControl();
  private _onDestroy = new Subject<void>();

  constructor(public apiMicroservice: ApiServiceService) {}
  ngOnInit(): void {
    if (Array.isArray(this.allStates) && this.allStates.length > 0) {
      this.defaultState = this.defaultState.filter((defaultVal) =>
        this.allStates.some((state) => state.value === defaultVal)
      );
      this.filteredListOfState = this.allStates.slice();
      this.stateNameFilterCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe((search: string) => {
          if (!search) {
            this.filteredListOfState = this.allStates.slice();
            return;
          }

          // Filter the list based on search value
          search = search.toLowerCase();
          this.filteredListOfState = this.allStates.filter((item) =>
            item.name.toLowerCase().includes(search)
          );
        });
    } else {
      console.warn('allStates is not an array. Ensure correct data input.');
    }
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  optionChange() {
    this.remarkChange.emit({
      index: this.index,
      val: this.defaultState,
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['defaultState']) {
      let value = changes['defaultState'].currentValue ?? [];
      if (typeof value === 'string') {
        value = value.split(',').map((x) => x.trim());
      }
      this.defaultState = [...value];
    }

    if (changes['allStates']) {
      this.filteredListOfState = [...this.allStates];
    }
  }
}
